import { getArgsAsTypesafeObjectProperties } from "../constants-util";

export const constants = getArgsAsTypesafeObjectProperties(
  "NotificationSettingsGetAll",
  "NotificationSettingsSaveLimit",
  "NotificationSettingsSaveEmailSettings",
  "NotificationSettingsSaveWebSettings"
);
